(function () {
  "use strict";
  var root = null, observer = null, controller = null;
  var generation = 0, isLoading = false, suspended = false;
  var loadedUrls = new Set();
  var productSelector = "product-list.product-list";

  function nextUrl(context) {
    var link = context && context.querySelector('.pagination a[rel="next"]');
    return link ? link.href : null;
  }
  function showLoading(show) {
    var loader = root && root.querySelector('.infinite-scroll-loading');
    if (loader) loader.style.display = show ? 'inline-block' : 'none';
  }
  function disconnect() {
    if (observer) observer.disconnect();
    observer = null;
  }
  function cancelPending() {
    generation += 1;
    if (controller) controller.abort();
    controller = null;
    isLoading = false;
    showLoading(false);
    disconnect();
  }
  function showFallback() {
    if (!root) return;
    var trigger = root.querySelector('#infinite-scroll-trigger');
    if (!trigger) return;
    disconnect();
    trigger.style.display = 'block';
    var button = trigger.querySelector('[data-infinite-retry]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button';
      button.setAttribute('data-infinite-retry', '');
      button.textContent = document.documentElement.lang.startsWith('tr') ? 'Daha Fazla Göster' : 'Load more';
      button.addEventListener('click', loadNextPage);
      trigger.appendChild(button);
    }
  }
  async function loadNextPage() {
    if (suspended || isLoading || !root) return;
    var url = nextUrl(root);
    if (!url || loadedUrls.has(url)) return;
    var requestGeneration = generation;
    var requestRoot = root;
    var container = root.querySelector(productSelector);
    if (!container) return;
    var requestController = new AbortController();
    controller = requestController;
    isLoading = true;
    showLoading(true);
    try {
      var response = await fetch(url, { credentials: 'same-origin', signal: requestController.signal });
      if (!response.ok) throw new Error('Page response: ' + response.status);
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (requestGeneration !== generation || requestController.signal.aborted || !container.isConnected) return;
      var newRoot = doc.getElementById(requestRoot.id);
      var newContainer = newRoot && newRoot.querySelector(productSelector);
      if (!newContainer) throw new Error('Product list missing from response');
      container.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      loadedUrls.add(url);
      var pagination = requestRoot.querySelector('.pagination');
      var newPagination = newRoot.querySelector('.pagination');
      if (pagination) pagination.innerHTML = newPagination ? newPagination.innerHTML : '';
      document.dispatchEvent(new CustomEvent('collection:products-added', { detail: { section: requestRoot } }));
      initObserver();
    } catch (error) {
      if (requestGeneration !== generation || requestController.signal.aborted) return;
      console.error('Infinite scroll:', error);
      showFallback();
    } finally {
      if (requestGeneration === generation && controller === requestController) {
        isLoading = false;
        controller = null;
        showLoading(false);
      }
    }
  }
  function initObserver() {
    disconnect();
    if (!root || suspended) return;
    var trigger = root.querySelector('#infinite-scroll-trigger');
    if (!trigger) return;
    trigger.querySelector('[data-infinite-retry]')?.remove();
    var url = nextUrl(root);
    if (!url || loadedUrls.has(url)) { trigger.style.display = 'none'; return; }
    trigger.style.display = 'block';
    if (!('IntersectionObserver' in window)) { showFallback(); return; }
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) loadNextPage();
    }, { rootMargin: '700px 0px', threshold: 0 });
    observer.observe(trigger);
  }
  function init() {
    var trigger = document.querySelector('#infinite-scroll-trigger');
    root = trigger ? trigger.closest('.shopify-section') : null;
    initObserver();
  }
  document.addEventListener('facet:loading', function (event) {
    if (root && event.detail.section !== root) return;
    if (!event.detail.section.querySelector(productSelector) && !root) return;
    root = event.detail.section;
    suspended = true;
    cancelPending();
  });
  document.addEventListener('facet:updated', function (event) {
    if (root && event.detail.section !== root) return;
    cancelPending();
    root = event.detail.section;
    loadedUrls.clear();
    suspended = false;
    initObserver();
  });
  document.addEventListener('facet:error', function (event) {
    if (event.detail.section !== root) return;
    suspended = false;
    initObserver();
  });
  document.addEventListener('shopify:section:load', function () {
    cancelPending();
    loadedUrls.clear();
    suspended = false;
    init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
